import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeForm from '../../../components/forms/RangeForm';
import { useRangeApi } from '../../../hooks/useRangeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { RangeDTO } from '../../../services/apiClient';

const RangeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useRangeApi();
  const [entityData, setEntityData] = useState<RangeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Ranges', href: '/admin/ranges' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Range data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating Range:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/ranges"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Range.Edit'
    >
        {entityData ? (
          <RangeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate(-1)}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default RangeEdit;